
const OmMap = {
    install (Vue) {
        Vue.prototype.$ommap = new Vue({
            data: {

            },
            methods:{

            },
            created:function(){
            },
            mounted () {
            },
            beforeMount:function(){

            }
        });
    },
    name:'OmMap'
};
export default OmMap;
